
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

/**
 * Redirects to dashboard if content is not found after loading
 */
export const useRedirectIfNotFound = (
  id: string | undefined, 
  contentItem: any | null, 
  isLoading: boolean, 
  hasAttemptedLoad: boolean,
  navigationInProgress: boolean
) => {
  const navigate = useNavigate();
  const redirectTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Clean up timeout on unmount or id change
    return () => {
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current);
        redirectTimeoutRef.current = null;
      }
    };
  }, [id]);

  useEffect(() => {
    if (!isLoading && !contentItem && hasAttemptedLoad && !navigationInProgress && id) {
      console.log("[NAVIGATION DEBUG] Content not found after retries, setting redirect timeout");
      
      if (redirectTimeoutRef.current) {
        clearTimeout(redirectTimeoutRef.current);
      }
      
      redirectTimeoutRef.current = setTimeout(() => {
        console.log("[NAVIGATION DEBUG] Redirecting to dashboard after content not found");
        toast.error("Content not found");
        navigate('/dashboard');
      }, 2000);
      
      return () => {
        if (redirectTimeoutRef.current) {
          clearTimeout(redirectTimeoutRef.current);
        }
      };
    }
    
    if (contentItem && redirectTimeoutRef.current) {
      clearTimeout(redirectTimeoutRef.current);
      redirectTimeoutRef.current = null;
    }
  }, [contentItem, isLoading, navigate, navigationInProgress, id, hasAttemptedLoad]);
};
